import { FormattedMessage } from 'react-intl'
import Heading from 'LuxKit/Typography/Heading'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FormatCurrency from 'components/Common/FormatCurrency'
import FormatLoyaltyPoints from 'loyalty/components/Formatters/FormatLoyaltyPoints'

interface Props {
  points: number
  cash: number
  /** Non-member cash total. When defined, shows the "Non-member" line. */
  nonMemberCash?: number
  /** Non-member points display. Defaults to `points` if not provided. */
  nonMemberPoints?: number
  unitLabel?: string
  /** Heading size — 'L' uses heading4 (default), 'S' uses heading6 (sticky header, cart). */
  size?: 'L' | 'S'
  /** Currency format — 'roundedDollar' (default, offer page) or 'preciseDollar' (cart). */
  currencyFormat?: 'roundedDollar' | 'preciseDollar'
  'data-testid'?: string
}

/**
 * Shared reward bundle price display: "{points} + {cash}" heading with optional
 * non-member line. Used across Flash Hotel charter summary, price details, and
 * with-flights sections.
 */
function RewardBundlePriceDisplay({ points, cash, nonMemberCash, nonMemberPoints, unitLabel, size = 'L', currencyFormat = 'roundedDollar', ...rest }: Props) {
  const isMember = nonMemberCash !== undefined
  const headingVariant = size === 'S' ? 'heading6' : 'heading4'
  return (
    <VerticalSpacer gap={4}>
      <Group direction="horizontal" gap={4} verticalAlign="baseline" wrap="wrap" data-testid={rest['data-testid']}>
        <Heading variant={headingVariant} colour={isMember ? 'lux-plus' : undefined}>
          <FormattedMessage
            id="vXhZGmIfMyC_-rHIu6nw"
            defaultMessage="{points} + {cash}"
            
            values={{
              points: <FormatLoyaltyPoints points={points} abbreviated />,
              cash: <FormatCurrency value={cash} format={currencyFormat} />,
            }}
          />
        </Heading>
        {unitLabel && <Caption variant="medium" colour={isMember ? 'lux-plus' : 'neutral-three'} weight="normal">
          {unitLabel}
        </Caption>}
      </Group>
      {isMember && (
        <Caption variant="medium" colour="neutral-two">
          <FormattedMessage
            id="dDulXESd_Db1yZjxr1Y5"
            defaultMessage="Non-member {price}"
            
            values={{
              price: <b><FormattedMessage
                id="85aL5CBVeEi7IW_heQL9"
                defaultMessage="{points} + {cash}"
                
                values={{
                  points: <FormatLoyaltyPoints points={nonMemberPoints ?? points} abbreviated />,
                  cash: <FormatCurrency value={nonMemberCash} format={currencyFormat} />,
                }}
              />
              </b>,
            }}
          />
        </Caption>
      )}
    </VerticalSpacer>
  )
}

export default RewardBundlePriceDisplay
